export default {
  queryHistoryPointList: '/courier-sqp-api/h5/v1/queryHistoryPointList'
}
